import React, { ReactElement } from 'react';
import TableRow from '../../../../components/table-row/table-row.component';
import TableCell from '../../../../components/table-cell/table-cell.component';
import Tooltip from '../../../../components/tooltip/tooltip.component';
import ActionButton from '../../../../components/action-button/action-button.component';
import ListItem from '../../../../components/list-item/list-item.component';
import ListItemText from '../../../../components/list-item-text/list-item-text.component';
import FormFieldText from '../../../../components/form-field-text/form-field-text.component';
import RemoveIcon from '../../../../icons/remove-icon';
import FormService from '../../../../services/form-service';

const DealTermRowForm: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isActive,
    isListItem,
    inputRefs,
    dealTermData,
    dealTermGroupData,
    dealTermIndex,
    onDeleteClick,
  } = props;

  const formKeyDealTermGroup: string = FormService.getIndexedFormFieldKey(dealTermGroupData.id);
  const formKeyDealTerm: string = FormService.getIndexedFormFieldKey(dealTermData.id);
  const formPrefix: string = `dealData.dealTermsData[${formKeyDealTermGroup}].terms[${formKeyDealTerm}]`;
  const fieldIndexName: number = 1;
  const fieldIndexValue: number = 2;

  return (
    !isListItem ? (
      <TableRow isActive={isActive}>
        <TableCell width="30%">
          <FormFieldText isHidden name={`${formPrefix}.id`} />
          <FormFieldText
            name={`${formPrefix}.name`}
            placeholder="Name"
            inputRefs={inputRefs}
            inputRefIndex={`${dealTermIndex}.${fieldIndexName}`}
          />
        </TableCell>
        <TableCell>
          <FormFieldText
            isInline
            isMultiline
            name={`${formPrefix}.content`}
            placeholder="Value"
            maxRows={FormService.TEXTAREA_MAX_ROWS_MEDIUM}
            minRows={FormService.TEXTAREA_MIN_ROWS_DEFAULT}
            inputRefs={inputRefs}
            inputRefIndex={`${dealTermIndex}.${fieldIndexValue}`}
          />
        </TableCell>
        <TableCell isTextRight width="5%">
          <Tooltip title="Delete">
            <ActionButton isInline withSmallPadding onClick={onDeleteClick}>
              <RemoveIcon />
            </ActionButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    ) : (
      <ListItem isActive={isActive}>
        <ListItemText isBlock>
          <FormFieldText name={`${formPrefix}.name`} placeholder="Name" />
        </ListItemText>
        <ListItemText isBlock isBlockRight>
          <FormFieldText
            isInline
            isMultiline
            name={`${formPrefix}.content`}
            placeholder="Value"
            maxRows={FormService.TEXTAREA_MAX_ROWS_MEDIUM}
            minRows={FormService.TEXTAREA_MIN_ROWS_DEFAULT}
          />
        </ListItemText>
        <ListItemText isBlock isBlockRight>
          <Tooltip title="Delete">
            <ActionButton isInline withSmallPadding onClick={onDeleteClick}>
              <RemoveIcon />
            </ActionButton>
          </Tooltip>
        </ListItemText>
      </ListItem>
    )
  );
});

export default DealTermRowForm;
